import {EVENTS_NAME, TOTAL_PROFESSIONAL_LEAD_TRIGGERED_DETAIL} from '../../config.js'

const {LEAD_TRIGGERED_EMAIL_DETAIL} = EVENTS_NAME

// INPUT:  event='Lead Triggered', lead_type='Detail Ad Replied Email', page_name_origin='detail'
// OUTPUT profesional: ['Total Leads Detalle Profesionales', 'Lead Detalle Profesionales Mensaje']
// OUTPUT particular:  ['Lead Triggered Email Detail']

export const getEmailDetailEvents = ({event, properties, isProfessionalSeller}) => {
  const matches =
    event === LEAD_TRIGGERED_EMAIL_DETAIL.EVENT &&
    properties.lead_type === LEAD_TRIGGERED_EMAIL_DETAIL.LEAD_TYPE &&
    properties.page_name_origin === LEAD_TRIGGERED_EMAIL_DETAIL.PAGE_NAME_ORIGIN

  if (!matches) return []

  return isProfessionalSeller
    ? [TOTAL_PROFESSIONAL_LEAD_TRIGGERED_DETAIL, LEAD_TRIGGERED_EMAIL_DETAIL.EVENT_OPTIMIZELY_PROFESSIONAL]
    : [LEAD_TRIGGERED_EMAIL_DETAIL.EVENT_OPTIMIZELY]
}
